import React from 'react';
import PropTypes from 'prop-types';

import {
  Wrapper,
  Header,
  Title,
  Text
} from './styled';

const PrerequisitesCard = ({
  title,
  description,
  headerExtra,
  children,
  className
}) => {
  return (
    <Wrapper className={ className }>
      <Header>
        <Title>{title}</Title>
        {headerExtra}
      </Header>
      {children || <Text>{description}</Text>}
    </Wrapper>
  );
};

PrerequisitesCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  headerExtra: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string
};

PrerequisitesCard.defaultProps = {
  description: '',
  headerExtra: null,
  children: null,
  className: ''
};

export default PrerequisitesCard;
